//import "babel-polyfill";
import preact from 'preact';
import CcNotificationsBadge from './components/common/CcNotificationsBadge';
import { callRemoteAPI, setStateFromLocalStorage, updateLocalStorage } from './components/utils/utils';
const { h, render, Component } = preact;
require('preact/devtools');

class TopBar extends Component {
	constructor() {
		super();
		this.state = {
			userIsLoggedIn: false,
			username: null,
         userId: 0,
         isMenuVisible: false
		};
		
      this.openLoginDialog = this.openLoginDialog.bind(this);
      this.externalUrl={
         shop : 'https://shop.ilfattoquotidiano.it/profilo?utm_source=ifq&utm_medium=header&utm_campaign=profilelink',
         premium : 'https://www.ilfattoquotidiano.it/premium',
         newsletter: 'https://shop.ilfattoquotidiano.it/newsletter/',
         assistenza: 'mailto:assistenza@ilfattoquotidiano.it'
      }
		this.openExternal = this.openExternal.bind(this);
		this.openPanel = this.openPanel.bind(this);
   }
   
	componentDidMount() {
      setStateFromLocalStorage(this, `${this.props.apiEndpoint}/?ifq-user-api=load-data`);
      // this.setState(prevState => {
      //    return {
      //       username : this.props.username,
      //       userId : this.props.userId,
      //       userIsLoggedIn : this.props.username && this.props.userId ? true : false
      //    }
      // })
   }
   toggleMenu(){
      if(!this.props.mobile) return;
      this.setState(prevState=>{
         return {isMenuVisible: !prevState.isMenuVisible}
      })
   }
	openLoginDialog() {
		var newwindow = window.open(this.props.loginURL, '', 'height=510,width=680');
		var l = setInterval(function() {
			if (newwindow.closed) {
				clearInterval(l);
				window.location.reload();
			}
		}, 500);
		return false;
	}
	openExternal(target) {
      window.open(this.externalUrl[target]);
	}
	openPanel(destination) {
		window.openUserDetails(this.state.userId, null, true, this.state.username, destination ? destination : 'comments');
	}
	render() {
		if (this.state.userIsLoggedIn) {
			return (
				<span class="user-welcome">
					<div class="user-topbar-username">
						<span onClick={()=>this.toggleMenu()}>
							<i class="icon-user" />
							{!this.props.mobile && this.state.username}
						</span>
						<CcNotificationsBadge {...this.props} enablePollingAPI={true} />
						<ul class={this.state.isMenuVisible ? `user-topbar-menu user-topbar-menu-visible` : `user-topbar-menu`}>
							<li class="user-topbar-notifications" onClick={()=>this.openPanel('comments')}>Gestione Commenti{' '}</li>
                     <li class="user-topbar-notifications" onClick={()=>this.openPanel('data')}>Gestione Dati Utente{' '}</li>
							<li class="user-topbar-profile" onClick={()=>this.openExternal('shop')}>Il mio Profilo</li>
							<li class="user-topbar-premium" onClick={()=>this.openExternal('premium')}>Leggi Il Fatto Quotidiano</li>
                     <li className="user-topbar-newsletter" onClick={()=>this.openExternal('newsletter')}>Newsletter</li>
                     <li className="user-topbar-assistenza" onClick={()=>this.openExternal('assistenza')}>Assistenza</li>
                     
                     <li class="user-topbar-logout">
                        <a href={this.props.logoutURL} class="user-logout action-logout" id="logout">
                           Esci
                        </a>
                     </li>
						</ul>
					</div>
				</span>
			);
		} else {
			return (
				<a href="#" class="user-login-btn" onClick={this.openLoginDialog}>
					Accedi
               <i class="icon-user" />
				</a>
			);
		}
	}
}
window.TopBar = TopBar;
window.preact = preact;



// WEBPACK FOOTER //
// ./user-topbar.js